import { render, staticRenderFns } from "./back-printing.vue?vue&type=template&id=4628b6e8"
import script from "./back-printing.vue?vue&type=script&lang=ts"
export * from "./back-printing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports